import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";

export const generateMeetingToken = (
  appId: number,
  serverSecret: string,
  consultationId: string,
  userId: string,
  userName: string
) => {
  try {
    return ZegoUIKitPrebuilt.generateKitTokenForTest(
      appId,
      serverSecret,
      consultationId,
      userId,
      userName
    );
  } catch (error) {
    console.error('Failed to generate meeting token:', error);
    throw new Error('Failed to generate meeting credentials');
  }
};